export const pathCustomers = {
  list: "/customers",
  detail: "/customers/:id",
  equipments: "/customers/:id/equipments",
};
export const pathCustomerUsers = {
  list: "/customer/:customer/users",
};
export const pathSubsidiary = {
  list: "/customer/:customer/subsidiarys",
  detail: "/subsidiary/:id",
  equipments: "/customer/:customer/subsidiary/:subsidiary/equipments",
};
export const pathPact = {
  list: "/customer/:customer/subsidiary/:subsidiary/pacts",
};

export const pathConfig = {
  type_equipments: "/equipment-types",
  type_orders: "/order-types",
  job_positions: "/job-positions",
  category_user: "/category-user",
  cargos: "/cargos",
  user: "/user",
  policy: "/policy",
  refrigerantes:"/configuracion/refrigerante/listado",
  causa_raiz:"/configuracion/causa-raiz"
};

export const pathMaintenancePlan = {
  list: "/maintenance-plan",
  save: "/maintenance-plan/:id",
};

export const pathRoadmap = {
  list: "/roadmaps",
  save: "/roadmaps/:id",
};

export const pathOrder = {
  list: "/order-list",
  calendar: "/order-calendar",
};

export const pathMyOrders = "/my-orders";

export const pathSchedulePlans = "/schedule-plans";

export const pathMyEquipments = "/my-equipments";
export const pathMyMaintenances = "/my-maintenance";

export const pathMonitoringUser = "/users/monitoring";
export const pathMonitoringLocation = "/monitoring/report-location";

export const pathMaterial = "/accountant/materials";

// T2/100A01: Rutas del módulo nuevo Gestion Compras (Pricebook), paralelo al
// Price book de pathMaterial, que no cambia. Pantallas en src/features/gestion-compras.
export const pathGestionCompras = {
  pricebook: "/gestion-compras/pricebook",
  pricebookGroups: "/gestion-compras/pricebook/groups",
  // T2/100A35: facturas de compra (Registrar factura).
  invoices: "/gestion-compras/facturas",
  invoiceNew: "/gestion-compras/facturas/nueva",
  invoiceEdit: "/gestion-compras/facturas/:invoice_id",
  // T2/100A40: consumo por orden y desperdicio.
  consumptions: "/gestion-compras/consumos",
  // T2/100A73: bodegas (REACT_APP_COMPRAS_BODEGAS_V2=true).
  warehouses: "/gestion-compras/bodegas",
  // T2/100A97: spend plan v2 (consulta por orden y aprobaciones de gerencia > 100 %).
  spendPlan: "/gestion-compras/spend-plan",
  // T2/100A99: Herramientas v2 (valor, traslados, carga inicial, tablero).
  tools: "/gestion-compras/herramientas",
  // T2/100A198: proveedores (CRUD básico; la carga de facturas también los crea o actualiza).
  suppliers: "/gestion-compras/proveedores",
  // T2/100A217: inventario y kardex.
  inventory: "/gestion-compras/inventario",
  // T2/100A218: reportes del Pricebook en página completa.
  pricebookReports: "/gestion-compras/reportes",
};

export const pathOrderMaterial = "/accountant/orders-materials";

export const pathTools = "/accountant/tools";

export const pathWarehouse = "/accountant/warehouse";

export const pathToolOrder = "/accountant/tool-order";

export const pathInventory = "/accountant/warehouse/:warehouse/inventory";

export const pathReportMaintenances = "/report/maintenances";
export const pathReportMinorBox = "/report/minor-box";
export const rutaReporteCausaRaiz='/report/root-cause'
export const rutaReporteSlaCotizacion='/report/sla-cotizacion'
export const rutaReporteSlaCorrectivos='/report/sla-correctivos' // legacy, redirects to rutaReporteEntregaCorrectivos
export const rutaReporteEntregaCorrectivos='/report/entrega-correctivos'
export const rutaReporteSlaEmergencias='/report/sla-emergencias'
export const rutaReportePendingReviews='/report/pending-equipment-reviews'

export const pathConfigSite = "/config-site";

export const pathFeedback = "/config/feedback";

export const pathProjects = "/projects";
export const pathProjectsActivities = "/projects/activities";

export const pathDesign = "/design";

export const pathPrintVisit = "/project/:project/visit/:visit";

export const pathEditVisit = "/project/:project/visit/:visit/edit";

export const rutaCotizaciones = "/marker-rates";
export const rutaCotizacionesDashboard = "/marker-rates/dashboard";
export const rutaCotizacionesUN = "/marker-rates/briefcase";
export const rutaAgregarCotizacion = "/save-marker-rates/:id";
export const rutaUnidades = "/settings/measures";
export const rutaCotizacionEstado = "/marker-rates/settings/status";

export const pathSiigoDashboard = "/financiero/dashboard";

export const pathCrm = {
  dashboard: "/ventas/crm",
  competitors: "/ventas/competidores",
};

export const pathContracts = {
  dashboard: "/ventas/contratos",
  mine: "/ventas/mis-contratos",
};

export const pathDashboardEjecutivo = "/dashboard-ejecutivo";

export const pathBilling = '/billing';

export const pathBovedas = {
  list: "/bovedas",
  detail: "/bovedas/:id",
};

export const pathCostParameters = "/administrativo/costos-laborales";

export const pathActivosTi = {
  list: "/activos-ti",
  detail: "/activos-ti/:id",
};

export const pathSolicitudAdmin = {
  list: "/solicitudes-admin",
};

export const pathSolicitudAltaUsuario = {
  list: "/solicitudes-alta-usuario",
};

export const pathControlCambios = '/control-cambios';
export const pathMisReportes = '/control-cambios/mis-reportes';

export const pathOutlookConnect = '/configuraciones/outlook';

export const pathMiFirma = '/configuraciones/firma';

// T2/100A140: Configuraciones › Calendario laboral (días laborales y festivos de Colombia).
export const pathCalendarioLaboral = "/configuraciones/calendario-laboral";
// T2/100A141: Configuraciones › SLA (plazos de servicio de gerencia, modificables solo por gerencia).
export const pathConfigSla = "/configuraciones/sla";
// T2/100A142: Configuraciones › Configuración de KPI (metas por departamento, con base en los SLA).
export const pathConfigKpis = "/configuraciones/kpis";

export const pathPortal = {
  home: "/portal",
  sede: "/portal/sede/:id",
  solicitudes: "/portal/solicitudes",
  cotizaciones: "/portal/cotizaciones",
  informes: "/portal/informes",
};

// Global Solicitudes module. The legacy /servicios/solicitudes route (kept in
// pathServicios below) redirects here permanently: stored notifications and
// bookmarks still point at it, so never remove it.
export const pathSolicitudes = "/solicitudes";
// LEGACY: redirect-only ("Mis casos" is now the "Mías" tab of /solicitudes).
export const pathSolicitudesMisCasos = "/solicitudes/mis-casos";

export const pathServicios = {
  // LEGACY: redirect-only, see pathSolicitudes.
  solicitudes: "/servicios/solicitudes",
  dashboard: "/servicios/dashboard",
};

// Print-only routes: visited by jag-backend's Puppeteer PDF routes
// (GET /cotizacion/:id/pdf, GET /order/:id/informe/pdf) and, for manual QA,
// by a developer's own browser. No app chrome, no login redirect — they
// authenticate via a `?token=` short-lived JWT instead (see
// components/Print/PrintGate.js). Registered outside Entry's normal
// `authed` gate — see App.js.
export const pathPrintCotizacion = "/print/cotizacion/:id";
export const pathPrintInforme = "/print/informe/:id";
export const pathPrintCronograma = "/print/cronograma/:id";
